"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates an object with a regex and a replacement pair to be processed.
 *
 * @param {Array}   rule        A pair or triplet of strings of which the first one is the regex to match
 *                              and the second (and the third) is the replacement.
 * @param {string}  [flags=i]   The regex flags to use.
 *
 * @returns {{ reg: RegExp, repl: string }|{ reg: RegExp, repl1: string, repl2: string }} Object to be used in the regex-based rules.
 */

var createSingleRuleFromMorphologyData = function createSingleRuleFromMorphologyData(rule) {
  var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "i";

  if (rule.length === 2) {
    return {
      reg: new RegExp(rule[0], flags),
      repl: rule[1]
    };
  }

  if (rule.length === 3) {
    return {
      reg: new RegExp(rule[0], flags),
      repl1: rule[1],
      repl2: rule[2]
    };
  }
};
/**
 * Creates an array of objects with a regex and a replacement pair to be processed.
 *
 * @param {Array}   rules       An array with pairs or triplets of strings of which the first one is the regex to match
 *                              and the second (and the third) is the replacement.
 * @param {string} [flags=i]    The regex flags to use.
 *
 * @returns {Array} Array of objects to be used in the regex-based rules.
 */


var createRulesFromMorphologyData = function createRulesFromMorphologyData(rules) {
  var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "i";
  return rules.map(function (rule) {
    return createSingleRuleFromMorphologyData(rule, flags);
  });
};

exports.createSingleRuleFromMorphologyData = createSingleRuleFromMorphologyData;
exports.createRulesFromMorphologyData = createRulesFromMorphologyData;
exports.default = createRulesFromMorphologyData;